"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var liquidService_1 = require("@/Types/liquidService");
var dompurify_1 = __importDefault(require("dompurify"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AppTemplateEditor_module_css_1 = __importDefault(require("./AppTemplateEditor.module.css"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var inertia_1 = require("@inertiajs/inertia");
var react_i18next_1 = require("react-i18next");
var AppTemplateInfoTab_1 = __importDefault(require("./AppTemplateInfoTab"));
var AppTemplateTab_1 = __importDefault(require("./AppTemplateTab"));
var AppTemplateSettingsTab_1 = __importDefault(require("./AppTemplateSettingsTab"));
var AppTemplateTranslationsTab_1 = __importDefault(require("./AppTemplateTranslationsTab"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var pro_solid_svg_icons_2 = require("@fortawesome/pro-solid-svg-icons");
var DeveloperToolbar_1 = __importDefault(require("../DeveloperToolbar"));
var AppTemplateMediaTab_1 = __importDefault(require("./AppTemplateMediaTab"));
var AppTemplateResourcesTab_1 = __importDefault(require("./AppTemplateResourcesTab"));
var dummyContext = {
    people: ["alice", "bob", "carol"],
};
var AppTemplateEditor = function (_a) {
    var appTemplateData = _a.appTemplateData;
    var _b = (0, react_1.useState)(function () { return (__assign({}, appTemplateData)); }), localAppTemplateData = _b[0], setLocalAppTemplateData = _b[1];
    var _c = (0, react_1.useState)(localAppTemplateData.template), templateContent = _c[0], setTemplateContent = _c[1];
    var _d = (0, react_1.useState)(JSON.stringify(dummyContext, null, 2)), contextData = _d[0], setContextData = _d[1];
    var _e = (0, react_1.useState)(dummyContext), parsedContext = _e[0], setParsedContext = _e[1];
    var _f = (0, react_1.useState)(""), contextError = _f[0], setContextError = _f[1];
    var _g = (0, react_1.useState)(""), renderedOutput = _g[0], setRenderedOutput = _g[1];
    var _h = (0, react_1.useState)("Template"), activeTab = _h[0], setActiveTab = _h[1];
    var _j = (0, q_play_components_1.useModal)(), isShown = _j.isShown, toggle = _j.toggle;
    var dataProvider = (0, AjaxProvider_1.default)("/api");
    var logger = q_play_core_1.logManager.getLogger();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var templateTabRef = (0, react_1.useRef)(null);
    var resourcesTabRef = (0, react_1.useRef)(null);
    var tabs = [
        { name: "Template Info", icon: pro_solid_svg_icons_2.faMemoCircleInfo },
        { name: "Resources", icon: pro_solid_svg_icons_1.faPuzzle },
        { name: "Template", icon: pro_solid_svg_icons_1.faCode },
        { name: "Settings", icon: pro_solid_svg_icons_1.faSliders, dataCy: "settingsTab" },
        { name: "Translations", icon: pro_solid_svg_icons_1.faLanguage },
        { name: "Media", icon: pro_solid_svg_icons_1.faImages },
    ];
    var handleBackToDeveloperPage = function () {
        inertia_1.Inertia.visit("/developer");
    };
    var handleContextChange = function (val) {
        setContextData(val);
        var parsedJson;
        try {
            parsedJson = JSON.parse(val);
            setParsedContext(parsedJson);
            setContextError("");
        }
        catch (error) {
            setContextError("Invalid JSON: " + error.message);
            setRenderedOutput("");
            return;
        }
        (0, liquidService_1.renderTemplate)(templateContent, parsedJson)
            .then(function (rawHtml) { return setRenderedOutput(dompurify_1.default.sanitize(rawHtml)); })
            .catch(function () { return setRenderedOutput(""); });
    };
    (0, react_1.useEffect)(function () {
        if (contextError) {
            setRenderedOutput("");
            return;
        }
        (0, liquidService_1.renderTemplate)(templateContent, parsedContext)
            .then(function (rawHtml) { return setRenderedOutput(dompurify_1.default.sanitize(rawHtml)); })
            .catch(function () { return setRenderedOutput(""); });
    }, [templateContent, parsedContext, contextError]);
    var handleTabChange = function (nextTab) {
        if (nextTab === "Template Info") {
            toggle();
        }
        else {
            setActiveTab(nextTab);
        }
    };
    var handleTemplateSaved = function (newTemplate) {
        setLocalAppTemplateData(function (prev) { return (__assign(__assign({}, prev), { template: newTemplate })); });
    };
    var saveTemplateInfo = function (newName, isPublic, isVisible) { return __awaiter(void 0, void 0, void 0, function () {
        var resource, payload, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    resource = "app-templates/update/".concat(localAppTemplateData.id);
                    payload = {
                        name: newName,
                        public: isPublic,
                        visible: isVisible,
                    };
                    return [4 /*yield*/, dataProvider.update(resource, {
                            id: "",
                            data: payload,
                            previousData: {},
                        })];
                case 1:
                    _a.sent();
                    setLocalAppTemplateData(function (prev) { return (__assign(__assign({}, prev), { name: newName, public: isPublic, visible: isVisible })); });
                    toggle();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error updating template (Name/Public/Visible):", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleTranslationsUpdate = function (updatedTranslations) {
        setLocalAppTemplateData(function (prev) { return (__assign(__assign({}, prev), { translations: updatedTranslations })); });
    };
    var handleRemoveSetting = function (key) {
        var updatedSettings = __assign({}, localAppTemplateData.settings);
        delete updatedSettings[key];
        setLocalAppTemplateData(function (prev) { return (__assign(__assign({}, prev), { settings: updatedSettings })); });
    };
    var handleSettingsUpdated = function (newSettings) {
        setLocalAppTemplateData(function (prev) { return (__assign(__assign({}, prev), { settings: newSettings })); });
    };
    var renderTabContent = function () {
        switch (activeTab) {
            case "Template":
                return (react_1.default.createElement(AppTemplateTab_1.default, { ref: templateTabRef, appTemplateData: localAppTemplateData, templateContent: templateContent, onTemplateChange: setTemplateContent, contextData: contextData, onContextChange: handleContextChange, renderedOutput: renderedOutput, onTemplateSaved: handleTemplateSaved }));
            case "Settings":
                return (react_1.default.createElement(AppTemplateSettingsTab_1.default, { appTemplateData: localAppTemplateData, onRemoveSetting: handleRemoveSetting, onSettingsUpdated: handleSettingsUpdated }));
            case "Translations":
                return (react_1.default.createElement(AppTemplateTranslationsTab_1.default, { appTemplateData: localAppTemplateData, onTranslationsUpdate: handleTranslationsUpdate }));
            case "Resources":
                return (react_1.default.createElement(AppTemplateResourcesTab_1.default, { ref: resourcesTabRef, appTemplateData: localAppTemplateData, onResourcesUpdate: function (updatedResources) {
                        setLocalAppTemplateData(function (prev) { return (__assign(__assign({}, prev), { resources: updatedResources })); });
                    } }));
            case "Media":
                return react_1.default.createElement(AppTemplateMediaTab_1.default, { appTemplateData: localAppTemplateData });
            default:
                return null;
        }
    };
    var renderActionButton = function () {
        if (activeTab === "Template") {
            return (react_1.default.createElement(q_play_components_1.Button, { text: "Save Template", onClick: function () { var _a; return (_a = templateTabRef.current) === null || _a === void 0 ? void 0 : _a.handleSaveTemplate(); }, style: { width: "auto" } }));
        }
        else if (activeTab === "Resources") {
            return (react_1.default.createElement(q_play_components_1.Button, { text: "Add Resource", onClick: function () { var _a; return (_a = resourcesTabRef.current) === null || _a === void 0 ? void 0 : _a.handleAddResource(); }, style: { width: "auto" } }));
        }
        return null;
    };
    return (react_1.default.createElement("div", { className: "template-editor" },
        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["toolbar-area"] },
            react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["back-button"], onClick: handleBackToDeveloperPage, title: t("Back to developer page") },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowLeftFromLine, style: { marginRight: "8px" } })),
            activeTab === "Template" ? (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["code-editor-settings"], onClick: function (e) {
                    var _a, _b;
                    e.stopPropagation();
                    (_b = (_a = templateTabRef.current) === null || _a === void 0 ? void 0 : _a.openSettings) === null || _b === void 0 ? void 0 : _b.call(_a, e.currentTarget);
                } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faGear, size: "sm", style: { cursor: "pointer", color: "var(--info-color)" }, title: "Editor Settings" }))) : (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["code-editor-settings-hidden"] })),
            react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["toolbar-center"] },
                react_1.default.createElement(DeveloperToolbar_1.default, { tabs: tabs, activeTab: activeTab, onTabChange: handleTabChange }),
                react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["template-save-button-container"] }, renderActionButton()))),
        renderTabContent(),
        react_1.default.createElement(AppTemplateInfoTab_1.default, { isShown: isShown, toggle: toggle, appTemplateData: localAppTemplateData, onSave: saveTemplateInfo })));
};
exports.default = AppTemplateEditor;
